import { Directive, HostListener, Input } from '@angular/core';
import { Access } from 'app/pages/security/loginhistory/models/access';

@Directive({
  selector: '[appRowClick]'
})
export class RowClickDirective {
  @Input() appRowClick: (access: Access | MouseEvent) => void = () => { };

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.appRowClick) {
      this.appRowClick(event);
    }
  }
}
